import { SelectOption } from 'govwell-ui/components/Select/types'

import { UserDataFragment, UserType } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import UserSearch from '../../Selects/UserSearch'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  customDisplay?: (user: UserDataFragment) => React.ReactNode
  getIsOptionDisabled?: (option: SelectOption<UserDataFragment>) => boolean
  includeUsersFromAllOrganizations?: boolean
  initialOptions?: SelectOption<UserDataFragment>[]
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  recordUuids?: string[]
  type?: UserType
  userIdToGroupLabel?: Map<number, string>
} & SelectFieldProps<UserDataFragment, TKey>
const UserSearchField = <TKey extends string>({
  caption,
  customDisplay,
  field,
  getIsOptionDisabled,
  includeUsersFromAllOrganizations,
  initialOptions,
  isMultiSelect,
  isRequired,
  label,
  placeholder,
  recordUuids,
  type,
  userIdToGroupLabel,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  const commonProps = {
    caption,
    customDisplay,
    errorMessage,
    getIsOptionDisabled,
    includeUsersFromAllOrganizations,
    initialOptions,
    isInvalid,
    isRequired,
    label,
    onBlur: field.handleBlur,
    placeholder,
    recordUuids,
    type,
    userIdToGroupLabel,
  }
  if (isMultiSelect) {
    return (
      <UserSearch
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <UserSearch
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default UserSearchField
